<template>
  <div class="md:hidden bg-gray-100 dark:bg-gray-900/30 rounded-lg py-4 px-2">
    <div class="flex flex-col gap-2">
      <div class="inline-flex items-center shrink-0 gap-2 ">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"  width="28" height="28" fill="#718096">
          <path d="M64 48c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16h80V400c0-26.5 21.5-48 48-48s48 21.5 48 48v64h80c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64zM0 64C0 28.7 28.7 0 64 0H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm88 40c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H104c-8.8 0-16-7.2-16-16V104zM232 88h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H232c-8.8 0-16-7.2-16-16V104c0-8.8 7.2-16 16-16zM88 232c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H104c-8.8 0-16-7.2-16-16V232zm144-16h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H232c-8.8 0-16-7.2-16-16V232c0-8.8 7.2-16 16-16z"/>
        </svg>
        <span class="font-bold flex flex-col">
          <span>COMERCIO SELECCIONADO</span>
          <span>{{ merchant.company_name.toUpperCase() }}</span>
        </span>
      </div>

      <div v-if="merchants.length > 1">
        <nav class="flex flex-col" v-for="merch in merchants">
          <div v-if="merch.id != merchant.id">
            <hr class="h-1 bg-gray-300">
            <button 
              type="button"
              @click="attemptSend(merch.id)"
              class="block w-full py-2 px-2 text-gray-600 dark:text-gray-400 hover:opacity-50 text-left"
            >
                {{ merch.name.toUpperCase() }}
            </button>
          </div>
        </nav>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';

const emit = defineEmits(['attempt']);

const props = defineProps({
  merchant: Object,
  merchants: Array,
});


const attemptSend = (id) => {
  emit('attempt', { id});
};
</script>

